/** @format */
import { createContext, useReducer, useContext } from 'react';
import { appReducer } from '../Reducers/reducer.app';
import { THEMES } from '../Constants/commons';
const AppContext = createContext();

export const FILTER_NAMES = {
  PARAMETER: 'PARAMETER',
  DATERANGE: 'DATERANGE',
  CALC_DATERANGE: 'CALC_DATERANGE',
};

const initialState = {
  isDrawerOpen: false,
  activeTheme: localStorage.getItem('theme') || THEMES.LIGHT,
  userInfo: null, // parameter table
  attributeNames: [],
  filterSettings: null, // filter names and default values from back-end
  appFilters: {
    // used for front-end side for payload calculations
    [FILTER_NAMES.PARAMETER]: null,
    [FILTER_NAMES.DATERANGE]: null,
    [FILTER_NAMES.CALC_DATERANGE]: null,
  },
  layouts: {
    ddLayout: localStorage.getItem('ddlayout') || 4,
  },
};

function AppContextProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  function toggleDrawer() {
    dispatch({ type: 'TOGGLE_DRAWER' });
  }

  function updateTheme(theme) {
    dispatch({ type: 'UPDATE_THEME', payload: theme });
  }

  function updateFilters(name, value) {
    dispatch({ type: 'APP_FILTER', payload: { name, value } });
  }

  function updateFilterSettings(name, value) {
    dispatch({ type: 'FLT_SETTING', payload: { name, value } });
  }

  function updateUserInfo(userInfo) {
    dispatch({ type: 'USER_INFO', payload: userInfo });
  }

  function updateAttrNames(attributeNames) {
    dispatch({ type: 'ATTR_NAMES', payload: attributeNames });
  }

  function updatePageLayout(layout) {
    dispatch({ type: 'PAGE_LAYOUT', payload: layout });
  }

  const batchUpdateAppFilters = (filters) => {
    dispatch({ type: 'BATCH_APP_FILTER', payload: { filters } });
  };

  const ctx = {
    appStore: state,
    toggleDrawer,
    updateTheme,
    updateFilters,
    updateUserInfo,
    updateAttrNames,
    batchUpdateAppFilters,
    updateFilterSettings,
    updatePageLayout,
  };
  return <AppContext.Provider value={ctx}>{children}</AppContext.Provider>;
}

export function useAppContext() {
  return useContext(AppContext);
}

export default AppContextProvider;
